export const SitesFilterTypes = {
  quanity: 1,
  delivery: 2,
  weight: 3,
}